import Step from './step';
import Item from './item';
import './styles/index.scss';
const ExpandedStep = Step;
ExpandedStep.Item = Item;
export { Item };
export default ExpandedStep;
